import { Group } from '../features/navigation/AssetGroupsSlice';

export function normalizeGroupName(str: string | null | undefined): string {
  if (!str) return '';
  return str.replace(/\s+/g, '_').toLowerCase();
}

export function findGroupByNormalizedName(groups: Group[] | null | undefined, name: string): Group | undefined {
  if (!groups || !name) return undefined;
  const normalizedName = normalizeGroupName(name);
  for (const group of groups) {
    if (group.assetGroupName && normalizeGroupName(group.assetGroupName) === normalizedName) {
      return group;
    }
    const found = findGroupByNormalizedName(group.childGroups, name);
    if (found) return found;
  }
  return undefined;
}
